var _rect, _text, _rect2, _circle, _text2, _text3, _text4, _rect3, _circle2, _text5, _text6, _text7, _rect4, _circle3, _text8, _text9, _text0, _path, _rect5, _circle4, _text1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutAndusDifferenceOperationalValuePathwayDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 430,
    viewBox: "0 0 720 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Operational value pathway") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 718,
    height: 428,
    rx: 27,
    fill: "#EEF5FC",
    stroke: "#BED7EE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 43,
    fill: "#087CFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    dy: 0
  }, "FROM WORK TO VALUE"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 105,
    width: 190,
    height: 188,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#C9DDF1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 135,
    r: 16,
    fill: "#087CFF",
    fillOpacity: 0.13,
    stroke: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 139,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 190,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fontWeight: 850
  }, "UNDERSTAND")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 226,
    fill: "#536985",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 650,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 54,
    dy: 0
  }, "People, process,"), /*#__PURE__*/React.createElement("tspan", {
    x: 54,
    dy: 19
  }, "decisions and data."))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 105,
    width: 190,
    height: 188,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#C9DDF1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 293,
    cy: 135,
    r: 16,
    fill: "#FF2775",
    fillOpacity: 0.13,
    stroke: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 293,
    y: 139,
    textAnchor: "middle",
    fill: "#FF2775",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 287,
    y: 190,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fontWeight: 850
  }, "BUILD")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 287,
    y: 226,
    fill: "#536985",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 650,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 287,
    dy: 0
  }, "The right system for"), /*#__PURE__*/React.createElement("tspan", {
    x: 287,
    dy: 19
  }, "the environment."))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 105,
    width: 190,
    height: 188,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#C9DDF1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 526,
    cy: 135,
    r: 16,
    fill: "#30D6A1",
    fillOpacity: 0.13,
    stroke: "#30D6A1"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 526,
    y: 139,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 190,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fontWeight: 850
  }, "MEASURE")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 226,
    fill: "#536985",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 650,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 520,
    dy: 0
  }, "Adoption, productivity"), /*#__PURE__*/React.createElement("tspan", {
    x: 520,
    dy: 19
  }, "and control."))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222 199h32m-7-7 7 7-7 7M455 199h32m-7-7 7 7-7 7",
    fill: "none",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 330,
    width: 656,
    height: 62,
    rx: 15,
    fill: "#07152A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 361,
    r: 7,
    fill: "#30D6A1"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 366,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 850
  }, "MEASURABLE OPERATIONAL IMPROVEMENT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAndusDifferenceOperationalValuePathwayDesktop);
export default __webpack_public_path__ + "static/media/about-andus-difference-operational-value-pathway-desktop.a261438e0507cace492f9d5d7fcdfee4.svg";
export { ForwardRef as ReactComponent };